import { render, staticRenderFns } from "./BrochureRequestEdit.vue?vue&type=template&id=768c73dc&scoped=true&"
import script from "./BrochureRequestEdit.vue?vue&type=script&lang=js&"
export * from "./BrochureRequestEdit.vue?vue&type=script&lang=js&"
import style0 from "./BrochureRequestEdit.vue?vue&type=style&index=0&id=768c73dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c73dc",
  null
  
)

export default component.exports